import type { StripeError, StripeErrorType } from '@stripe/stripe-js';
import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

/**
 * Error passed to `onTokenInvalid` when Stripe returns an error result while creating or confirming a
 * payment method. Keeps the Stripe error's `type`, `code` and `declineCode` (no PII) so handlers can
 * tell user outcomes (validation errors, declines) apart from unexpected failures.
 */
export class StripeTokenInvalidError extends CustomError {
	readonly type: StripeErrorType;
	readonly code?: string;
	readonly declineCode?: string;

	constructor({ type, code, decline_code: declineCode, message }: StripeError) {
		super(message || 'Unhandled Error');
		this.type = type;
		this.code = code;
		this.declineCode = declineCode;
	}
}
setClassName(StripeTokenInvalidError, 'StripeTokenInvalidError');
